import "firebase/auth";
import "firebase/analytics";
import "firebase/functions";
import firebase from "firebase/app";

const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  appId: process.env.REACT_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// Access-Control-Allow-Origin

const app = firebase.initializeApp(config);


// else {
//   // const storage = app.storage();
//   // storage.settings({
//   //   host: "localhost:8080",
//   //   ssl: false,
//   // });
  
//   // Analytics only in production and staging.
//   // firebase.analytics();
// }

export default app;
